import { AUTH_TOKEN_KEY } from 'constants';

const getAuthenticationToken = () => {
    return localStorage.getItem(AUTH_TOKEN_KEY);
};

const isAuthenticated = (data) => {
    return data && ( Object.keys(data).length > 0 ) && data;
};

const getUserRole = (userData) => {
    return userData ? userData.role.name : null;
};

const getAllowedPermissions = (userData) => {
    const permissions = userData ? userData?.role?.permissions : {};
    return permissions;
};

const isUserOwnTheData = (userData, field, id) => {
    
    const fieldData = userData[field];

    if (fieldData.id === id) return true;

    return false;

};

const getDashBoardId = (userData) => {
    const dashboardId = userData ? userData?.role?.dashboardId : null;
    return dashboardId;
};

const isAuthenticatedRoleAdmin = (userData) => {
    const isAdmin = userData ? userData?.role?.isAdmin : false;
    return isAdmin;
};

const isAuthenticatedRoleTeamWise  = (userData) => {
    const isAdmin = userData ? userData?.role?.isTeamWise : false;
    return isAdmin;
};

export {
    getAuthenticationToken,
    isAuthenticated,
    getUserRole,
    getAllowedPermissions,
    isUserOwnTheData,
    getDashBoardId,
    isAuthenticatedRoleAdmin,
    isAuthenticatedRoleTeamWise,
};